import styled from 'styled-components'

export const SelectWrapper = styled.div`
  cursor: pointer;
  display: inline-block;
`

export const Dropdown = styled.div<{ $visible: boolean; $isTop: boolean }>`
  position: fixed;
  min-width: 140px;
  max-width: calc(100vw - 32px); // 防止超出屏幕
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 8px;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  transform: translateY(${(props) => (props.$isTop ? '10px' : '-10px')});
  pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
  transition: opacity 0.2s ease-in-out;
  z-index: 1000;
`

export const Option = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 8px;
  color: var(--Grays-Gray-1, #23262f);
  font-family: Rubik;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 19.5px */

  &:hover {
    background: var(--Background, #f7f5f4);
  }
`
